import {urlGenerator} from "../Helpers/AxiosHelper";


//Update
export const APP_UPDATE = `${urlGenerator('app/updates')}`;
export const APP_UPDATE_INSTALL = `${urlGenerator('app/updates/install')}`;

//Install
export const GENERATE_PURCHASE_CODE_URL = `${urlGenerator('setup/generate-url')}`;
export const GET_UPDATE_URL = `${urlGenerator('app/generated-update-url-purchase-code')}`;

export const CLEAR_CACHE= `${urlGenerator('app/clear-cache')}`;



